<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="600px"
    append-to-body=""
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :model="certificate"
      :rules="rules"
      label-width="110px">
      <el-form-item label="证书名称：">{{ certificate.certName }}</el-form-item>
      <el-form-item
        label="证书编号："
        prop="certNo">
        <el-input
          v-model.number="certificate.certNo"
          show-word-limit
          :maxlength="32"></el-input>
      </el-form-item>
      <el-form-item
        label="出证日期："
        prop="issuanceTime">
        <el-date-picker
          v-model="certificate.issuanceTime"
          style="width: 100%;"
          type="date"
          :editable="false">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="有效期："
        prop="time">
        <el-date-picker
          v-model="certificate.time"
          style="width: 100%;"
          type="daterange"
          unlink-panels
          :editable="false"
          range-separator=""
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="证书文件："
        prop="certFile">
        <upload-with-crop
          v-model="certificate.certFile"
          :limit="5"
          :isLt2M="500"
          :fixedNumber="[1,1]"
          :autoCropWidth="80"
          :autoCropHeight="80" />
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import UploadWithCrop from '../../../components/public/upload-with-crop.vue'
import Commom from '@/service/common'
export default {
  name: 'CertificateFileModal',
  components: { UploadWithCrop },
  data() {
    return {
      loading: false,
      visible: false,
      certificate: { vendorId: null, vendorName: '', certFileId: null, certId: null, certName: '', time: '', certFile: [], certNo: '', issuanceTime: null },
      rules: {
        certNo: [{ required: true, message: '请输入证书文件编号', trigger: 'blur' }],
        time: [{ required: true, message: '请选择有效期', trigger: 'blur' }],
        issuanceTime: [{ required: true, message: '请选择出证日期', trigger: 'blur' }],
        certFile: [{ required: true, message: '请上传证书文件', trigger: 'change' }]
      }
    }
  },
  computed: {
    title({ certificate }) {
      return certificate.certFileId ? '修改证书文件' : '新建证书文件'
    }
  },
  methods: {
    init(row = {}) {
      this.certificate = { ...this.certificate, ...row }
      this.visible = true
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
      this.certificate = { ...this.certificate, ...this.$options.data().certificate, time: undefined }
    },
    handleLoading(loading) {
      this.loading = loading
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          const { certFileId } = this.certificate
          Commom[certFileId ? 'updatecertificatefile' : 'addcertificatefile']({ ...this.certificate, ...this.getQuery(this.certificate) })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.loading = false
                this.visible = false
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    getQuery() {
      const { time, certFile, issuanceTime } = this.certificate
      return { certBeginTime: +time[0], certEndTime: +time[1], certFile: certFile.map(item => item.url).join(','), issuanceTime: +issuanceTime }
    }
  }
}
</script>
